import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { Typography } from '@mui/material';

import { TRAIN_TYPES, TRAIN_TYPES_MAP } from '../../config';

function getTrainTypeColor(trainType) {
  if (!trainType || typeof trainType !== 'string') {
    return '#616161'; // default color
  }
  const upperTrainType = trainType.toUpperCase();
  switch (upperTrainType) {
    case TRAIN_TYPES.POINT.toUpperCase():
      return '#f57f17';
    case TRAIN_TYPES.SUB.toUpperCase():
      return '#00897b'; // teal color for sub edits
    case TRAIN_TYPES.FSI:
      return '#2e7d32';
    case TRAIN_TYPES.FPI:
      return '#673ab7';
    case TRAIN_TYPES.FSD:
      return '#f44336';
    case TRAIN_TYPES.FPD:
      return '#b71c1c';
    case TRAIN_TYPES.NSGL:
      return '#f06292';
    case TRAIN_TYPES.NSF:
      return '#ba68c8';
    case TRAIN_TYPES.NST:
      return '#ffa726';
    case TRAIN_TYPES.EMPTY:
    default:
      return '#616161';
  }
}

export const NewTrainTypePill = ({ trainType, text }) => {
  const formattedTrainType = useMemo(() => {
    if (!trainType || typeof trainType !== 'string') {
      return trainType || '';
    }
    const upperTrainType = trainType.toUpperCase();
    if (['FSI', 'FPI', 'FSD', 'FPD', 'NST', 'NSF', 'NSGL'].includes(upperTrainType)) {
      return upperTrainType;
    }
    return trainType;
  }, [trainType]);

  return (
    <Typography
      sx={{
        boxSizing: 'border-box',
        fontSize: '14px',
        border: text
          ? '2px solid #1565c0'
          : `2px solid ${getTrainTypeColor(formattedTrainType)}`,
        color: text ? '#1565c0' : getTrainTypeColor(formattedTrainType),
        borderRadius: '16px',
        whiteSpace: 'nowrap',
        fontWeight: 700,
        padding: '4px 12px',
      }}
    >
      {text || TRAIN_TYPES_MAP[formattedTrainType] || 'Unknown'}
    </Typography>
  );
};

NewTrainTypePill.propTypes = {
  trainType: PropTypes.oneOf(Object.values(TRAIN_TYPES)),
  text: PropTypes.string,
};

NewTrainTypePill.defaultProps = {
  trainType: '',
  text: '',
};
